import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X } from "lucide-react";

const FloatingWhatsApp = () => {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const link =
    "https://wa.me/31641262267?text=" +
    encodeURIComponent("Hoi Tim, ik heb een vraag aan UPPIT.");

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.9, y: 20 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3"
        >
          <AnimatePresence>
            {open && (
              <motion.div
                initial={{ opacity: 0, y: 10, scale: 0.96 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: 10, scale: 0.96 }}
                transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                className="rounded-2xl bg-white border border-ivory-400 p-5 max-w-xs shadow-card-lift"
              >
                <div className="flex items-start gap-3">
                  <div className="w-11 h-11 rounded-full bg-electric grid place-items-center shrink-0">
                    <MessageCircle className="w-4 h-4 text-white" />
                  </div>
                  <div>
                    <div className="font-display font-bold text-lg text-coal leading-tight mb-1">Hoi, ik ben Tim</div>
                    <p className="text-sm text-coal/60 leading-relaxed">
                      Stel je vraag direct via WhatsApp — ik reageer meestal binnen een uur.
                    </p>
                    <a
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid="floating-whatsapp-cta"
                      className="mt-4 inline-flex items-center gap-2 bg-electric hover:bg-electric-600 text-white text-sm font-semibold rounded-full px-4 py-2 transition-colors"
                    >
                      Start gesprek <MessageCircle className="w-3.5 h-3.5" />
                    </a>
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>

          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="floating-whatsapp-fab"
            aria-label="WhatsApp met Tim"
            className="group relative w-14 h-14 rounded-full bg-electric grid place-items-center transition-all duration-300 hover:scale-105 shadow-glow-blue"
          >
            <span className="absolute inset-0 rounded-full bg-electric/40 blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            {open ? <X className="relative w-5 h-5 text-white" /> : <MessageCircle className="relative w-5 h-5 text-white" />}
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingWhatsApp;
